export default __webpack_public_path__ + "static/media/app.eb166e5a.svg";